export enum WorkDayType {
  HOLIDAY = 'HOLIDAY',
  NORMAL = 'NORMAL',
  HOLIDAY_NOT_ACCEPTED = 'HOLIDAY_NOT_ACCEPTED',
  NATIONAL_DAY = 'NATIONAL_DAY'
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-model/work-day-type.enum.ts